import { AxiosRequestConfig } from 'axios';
import instance from 'api';
import { IDynamicTableParams } from 'components/DynamicTable';
import { IAvailableColumnModel, IAvailableGroupColumnModel } from 'interfaces';
import { IMaterialsOutsourcing, IMaterialsOutsourcingType, IPosition } from './interfaces';

export const getMaterialsOutsourcingList = (params: IDynamicTableParams): Promise<IMaterialsOutsourcing[]> => {
  return instance()
    .post('/calculatorTariff/materialsOutsourcing/list', params)
    .then((response) => response.data);
};

export const getMaterialsOutsourcingListAll = (): Promise<IMaterialsOutsourcing[]> => {
  return instance()
    .post('/calculatorTariff/materialsOutsourcing/listAll')
    .then((response) => response.data);
};

export const getMaterialsOutsourcingAvailableColumns = (): Promise<IAvailableColumnModel[]> => {
  return instance()
    .post('/calculatorTariff/materialsOutsourcing/availableColumns')
    .then((response) => response.data);
};

export const getMaterialsOutsourcingAvailableGroupColumns = (): Promise<IAvailableGroupColumnModel[]> => {
  return instance()
    .post('/calculatorTariff/materialsOutsourcing/availableGroupColumns')
    .then((response) => response.data);
};

export const loadMaterialsOutsourcing = (materialsOutsourcingId: number) => {
  return instance()
    .get<IMaterialsOutsourcing>('/calculatorTariff/materialsOutsourcing/load/' + materialsOutsourcingId)
    .then((response) => response.data);
};

export const createMaterialsOutsourcing = (materialsOutsourcing: IMaterialsOutsourcing) => {
  return instance()
    .post<IMaterialsOutsourcing>('/calculatorTariff/materialsOutsourcing/save', materialsOutsourcing)
    .then((response) => response.data);
};

export const updateMaterialsOutsourcing = (materialsOutsourcing: IMaterialsOutsourcing) => {
  return instance()
    .post<IMaterialsOutsourcing>(
      `/calculatorTariff/materialsOutsourcing/${materialsOutsourcing.materialsOutsourcingId}/update`,
      materialsOutsourcing,
    )
    .then((response) => response.data);
};

export const deleteMaterialsOutsourcing = (materialsOutsourcingId: number) => {
  return instance()
    .post('/calculatorTariff/materialsOutsourcing/archive', { materialsOutsourcingId })
    .then((response) => response.data);
};

export const recoverMaterialsOutsourcing = (materialsOutsourcingId: number) => {
  return instance()
    .post('/calculatorTariff/materialsOutsourcing/recover', { materialsOutsourcingId })
    .then((response) => response.data);
};

export const getMaterialsOutsourcingTypes = (config?: AxiosRequestConfig) => {
  return instance()
    .post<IMaterialsOutsourcingType[]>(`/calculatorTariff/typeMaterialsOutsourcing/listAll`, {}, config)
    .then((response) => response.data);
};

export const getPositions = (config?: AxiosRequestConfig) => {
  return instance()
    .post<IPosition[]>(`/dictionary/positions`, {}, config)
    .then((response) => response.data);
};
